require('./bootstrap');

//require('@fortawesome/fontawesome-free/js/all');

require ('slick-carousel/slick/slick');
require ('lightgallery');
require ('lg-thumbnail');
require ('lg-autoplay');
require('jquery-mousewheel');

require('./countdown');
require('./carousel');
require('./main');